import gql from "graphql-tag";

export const getUnexpectedError = gql`
	query getUnexpectedError {
		unexpectedError @client {
			code
			message
			stack
			originalError {
				name
				message
			}
		}
	}
`;

export const setUnexpectedError = gql`
	mutation registerUnexpectedError($error: UnexpectedErrorInput) {
		setUnexpectedError(error: $error) @client
	}
`;
